import React from 'react';
import { useIntl } from 'react-intl';
import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../common/types';
import { usePresaveChecklist } from './usePresaveChecklist';
import { PresaveChecklistRow } from './PresaveChecklistRow';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole panel; each part uses its own slice of it */
import styles from './PresavePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PresaveChecklistProps {
  smartLink: SerializedSmartLink;
}

/** What is still wrong with the page, while there is time to fix it. */
const PresaveChecklistComponent: React.FC<PresaveChecklistProps> = ({ smartLink }) => {
  const intl = useIntl();
  const items = usePresaveChecklist({ smartLink });

  return (
    <div className={styles.checklist}>
      <h4 className={styles.checklistTitle}>
        {intl.formatMessage({ id: 'app.sml.presave.checklist.title', defaultMessage: 'Before release day' })}
      </h4>
      {items.map((item) => (
        <PresaveChecklistRow key={item.id} item={item} />
      ))}
    </div>
  );
};

export const PresaveChecklist = TypedMemo(PresaveChecklistComponent);
